import { useEffect, useSyncExternalStore } from 'react';
import { supabase } from './supabase';

/**
 * Leo on duty or on standby (Gary, 19 Oct): one switch per person. Available: you answer your chats within
 * 10 minutes and Leo stands by. Leo on duty: Leo answers your chats and your phone stays quiet for them.
 * Outside opening hours Leo is on duty for everyone whatever the switch says. Saved in Sentinel on the person
 * (messaging-send availability, users.chats_away_at); one copy shared by every screen that shows the switch.
 */
let onDuty: boolean | null = null;
let loading: Promise<void> | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

async function call(away?: boolean): Promise<boolean | null> {
  const { data, error } = await supabase.functions.invoke('messaging-send', { body: away === undefined ? { action: 'availability' } : { action: 'availability', away } });
  return error ? null : !!(data as { away?: boolean } | null)?.away;
}

function load() {
  loading ??= call().then((v) => { if (v !== null) { onDuty = v; emit(); } }).finally(() => { loading = null; });
}

/** Sets the switch; false when it did not save. */
export async function setLeoOnDuty(next: boolean): Promise<boolean> {
  const saved = await call(next);
  if (saved === null) return false;
  onDuty = saved;
  emit();
  return true;
}

/** Leo on duty for me (true), Available (false), or not known yet (null). */
export function useLeoOnDuty(live: boolean): boolean | null {
  const value = useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => onDuty);
  useEffect(() => { if (live && onDuty === null) load(); }, [live]);
  return value;
}
